import { render, staticRenderFns } from "./reference.vue?vue&type=template&id=9b0d24c4&scoped=true"
import script from "./reference.vue?vue&type=script&lang=js"
export * from "./reference.vue?vue&type=script&lang=js"
import style0 from "./reference.vue?vue&type=style&index=0&id=9b0d24c4&prod&lang=less&scoped=true"
import style1 from "./reference.vue?vue&type=style&index=1&id=9b0d24c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b0d24c4",
  null
  
)

export default component.exports